import React from "react";

const DashboardLoader = () => {
  return (
    <div className=" flex  items-center justify-center ">
      <span className="loading loading-spinner w-14 text-primary"></span>
    </div>
  );
};

export default DashboardLoader;
